import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { DataGridColumn } from './dataGridColumn';

export const DataGridTagsColumn = memo(({ ...rest }) => {
  const { styles } = useStyle();

  return (
    <DataGridColumn
      {...rest}
      renderColumn={(item, tags) => {
        return (
          <View style={styles.container}>
            {tags.map((tag) => (
              <View style={styles.itemContainer}>
                <Text style={styles.tagText}>{tag}</Text>
              </View>
            ))}
          </View>
        );
      }}
    />
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  itemContainer: {
    backgroundColor: colors.gray21,
    borderRadius: 5,
    padding: 3,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 2,
  },
  tagText: {
    color: colors.white,
    fontSize: 12,
  },
}));
